import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

/*
 * O carrinho guarda itens e quantidades — nada mais.
 * Preço/promoção/frete/total vêm do backend (quote e order), nunca daqui.
 */
export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  useEffect(() => {
    try {
      const savedCart = localStorage.getItem('cart');
      if (savedCart) {
        const items = JSON.parse(savedCart);
        // ids do catálogo antigo (estático) não servem para a API
        if (items.every((item) => typeof item.product?.id === 'number')) {
          setCart(items);
        } else {
          localStorage.removeItem('cart');
        }
      }
    } catch {
      localStorage.removeItem('cart');
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('cart', JSON.stringify(cart));
    } catch {
      // A arte original pode ser grande e estourar a cota do localStorage.
      // Mantém o carrinho em memória e persiste só os itens, sem a imagem.
      try {
        localStorage.setItem(
          'cart',
          JSON.stringify(cart.map((item) => ({ ...item, customImage: null })))
        );
      } catch {
        localStorage.removeItem('cart');
      }
    }
  }, [cart]);

  const addToCart = (product, customImage, options = {}) => {
    const newItem = {
      id: Date.now(),
      product,
      customImage,
      sizeLabel: options.sizeLabel || null,
      quantity: 1,
    };
    setCart([...cart, newItem]);
    setIsCartOpen(true);
  };

  const removeFromCart = (itemId) => {
    setCart(cart.filter((item) => item.id !== itemId));
  };

  const updateQuantity = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    setCart(cart.map((item) =>
      item.id === itemId ? { ...item, quantity: newQuantity } : item
    ));
  };

  const clearCart = () => {
    setCart([]);
  };

  // EXIBIÇÃO apenas: soma de preços unitários do catálogo.
  // O valor oficial (com bundles e frete) é o quote/total do backend.
  const getSubtotal = () => {
    return cart.reduce((total, item) => {
      let unitPrice = item.product.price || 0;
      if (item.sizeLabel && item.product.sizes) {
        const found = item.product.sizes.find(s => s.label === item.sizeLabel);
        if (found) unitPrice = parseFloat(found.price);
      }
      return total + unitPrice * item.quantity;
    }, 0);
  };

  const getTotalItems = () =>
    cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      getSubtotal,
      getTotalItems,
      isCartOpen,
      setIsCartOpen,
    }}>
      {children}
    </CartContext.Provider>
  );
};
